export default __webpack_public_path__ + "static/media/100_19806.634bafe7.jpg";